export default {
	type: 'object',
	properties: {
		parentId: { type: 'string' },
		lastKey: { type: 'string' },
	},
	required: ['parentId'],
	additionalProperties: true,
}
